import { createReducer, on } from '@ngrx/store';
import * as FlaringActions from './flaring.actions';
import { sgpFlaringInitialState } from './flaring.state';

export const SGPFlaringReducer = createReducer(
  sgpFlaringInitialState,
  on(FlaringActions.getChemicalCompound, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(FlaringActions.getChemicalCompoundSuccess, (state, result) => ({
    ...state,
    data: result.data,
    result: null,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false,
  })),
  on(FlaringActions.getChemicalCompoundFailure, (state, result) => ({
    ...state,
    result: result,
    isLoading: false,
    isLoadingSuccess: false,
    isLoadingFailure: true,
  })),
  on(FlaringActions.getChemicalCompoundsEquipment, (state, result) => ({
    ...state,
    isLoading: true,
  })),
  on(FlaringActions.getChemicalCompoundsEquipmentSuccess, (state, result) => ({
    ...state,
    dataEquipment: result.dataEquipment,
    result: null,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false,
  })),
  on(FlaringActions.getChemicalCompoundsEquipmentFailure, (state, result) => ({
    ...state,
    result: result,
    isLoading: false,
    isLoadingSuccess: false,
    isLoadingFailure: true,
  })),
  on(FlaringActions.getStreamsName, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(FlaringActions.getStreamsNameSuccess, (state, result) => ({
    ...state,
    streams: result.streams,
    result: null,
    isLoading: false,
    isLoadingSuccess: true,
    isLoadingFailure: false,
  })),
  on(FlaringActions.getStreamsNameFailure, (state, result) => ({
    ...state,
    result: result,
    isLoading: false,
    isLoadingSuccess: false,
    isLoadingFailure: true,
  })),
  on(FlaringActions.AddManualRecord, (state, payload) => ({
    ...state,
    isLoading: true,
  })),
  on(FlaringActions.AddManualRecordSuccess, (state, payload) => ({
    ...state,
    result: payload,
    isLoading: false,
    isLoadingSuccess: true,
  })),
  on(FlaringActions.AddManualRecordFailure, (state, payload) => ({
    ...state,
    result: payload.message,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FlaringActions.getLIMS, (state, payload) => ({
    ...state,
    isLoading: true,
  })),
  on(FlaringActions.getLIMSSuccess, (state, payload) => ({
    ...state,
    lims: payload.lims,
    isLoading: false,
    isLoadingSuccess: true,
  })),
  on(FlaringActions.getLIMSFailure, (state, payload) => ({
    ...state,
    result: payload.message,
    isLoading: false,
    isLoadingFailure: true,
  })),
  on(FlaringActions.startLocalLoading, (state) => ({
    ...state,
    localLoading: true,
  })),
  on(FlaringActions.stopLocalLoading, (state) => ({
    ...state,
    localLoading: false,
  }))
);
